'use strict';

/**
 *
 * @name: brandLive
 *
 */

import DirectiveTemplate from './nn-brand-live.directive.html';

function BrandLiveDirective(
  $translate,
  $stateParams,
  apiUserService,
  apiMemberSocialFeedService,
  brandAnalytics
) {

  'ngInject';

  return {
    restrict: 'A',
    template: DirectiveTemplate,
    scope: {
      content: '&',
      loaded: '='
    },
    link: function(scope, element) {

      var instagramSocialName;
      var IMAGES_LENGTH = 14;

      scope.item = scope.content();
      scope.brandAnalytics = brandAnalytics;
      scope.brandName = $stateParams.displayName;

      if (!scope.item.jsonData || !scope.item.jsonData.sources || !scope.item.jsonData.sources[0], !scope.item.jsonData.sources[0].userId) {

        terminate();
      }

      apiUserService
        .getAnotherUser(scope.item.jsonData.sources[0].userId)
        .then(function(res) {

          try {

            instagramSocialName = res.data.socialProfiles.instagram.url.match(/https*:\/\/.*instagram.com\/(.+)\/*/)[1].replace('/', '');
            scope.twitterSocialName = res.data.socialProfiles.twitter.url.match(/https*:\/\/.*twitter.com\/(.+)\/*/)[1].replace('/', '');
            getImages();
            getTweets();
          } catch (e) {

            console.error(e);
          }
        });

      /* private */

      function getTweets() {

        apiMemberSocialFeedService
          .twitter(scope.twitterSocialName)
          .then(function(response) {

            scope.tweets = response.items;
          });
      }

      function getImages() {

        apiMemberSocialFeedService
          .instagram(instagramSocialName)
          .then(function(response) {

            scope.images = response.items.splice(0, IMAGES_LENGTH);
            setupFeaturedImages();
          });
      }

      function setupFeaturedImages() {

        /*jshint camelcase: false */
        scope.featuredImage1 = scope.images.splice(randomNumber(IMAGES_LENGTH - 1), 1)[0];
        scope.featuredImageUrl1 = 'url("' + scope.featuredImage1.images.standard_resolution.url + '")';
        scope.featuredImage2 = scope.images.splice(randomNumber(IMAGES_LENGTH - 2), 1)[0];
        scope.featuredImageUrl2 = 'url("' + scope.featuredImage2.images.standard_resolution.url + '")';
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      function randomNumber(max) {

        return Math.floor(Math.random() * (max - 0 + 1) + 0);
      }
    }
  };
}

export default BrandLiveDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-brand-live/nn-brand-live.directive.js